import { render } from "./TagPage.vue?vue&type=template&id=b8af9dd0&scoped=true"
import script from "./TagPage.vue?vue&type=script&lang=js"
export * from "./TagPage.vue?vue&type=script&lang=js"

import "./TagPage.vue?vue&type=style&index=0&id=b8af9dd0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8af9dd0"]])

export default __exports__